import { Component, OnInit } from '@angular/core';
import { PoliciesVersionService } from '../services/policies-version.service';

@Component({
  selector: 'app-juridiction-modal',
  templateUrl: './juridiction-modal.component.html',
  styleUrls: ['./juridiction-modal.component.scss']
})
export class JuridictionModalComponent implements OnInit {

  constructor(private policiesVersionService:PoliciesVersionService) { }

  ngOnInit() {
  }
  updateEstoniaPolocyVersion() {
    this.policiesVersionService.updatePolocies(undefined, true);
  }

}
